import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
//自定义公共css引入
import '@/assets/css/common.scss'
//自定义ICON引入
import '@/assets/css/iconfont.css'
import '@/assets/css/theme/example.variables.scss'
//UI组件库
import ElementUI from 'element-ui'
//表格组件
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table-plugin-element/dist/style.css'
// 配置文件
// import config from './utils/config'
//加载配置文件
// axios.get(process.env.VUE_APP_PUBLICPATH + 'config.json?t='+new Date().getTime()).then(response => {
//   let redirectUrl = '';
//   let authUrl = '';
//   switch (process.env.NODE_ENV) {
//     case 'development':
//       redirectUrl = response.data.redirect_uri.default;
//       authUrl = response.data.authUrl.default;
//       break;
//     case 'test':
//       redirectUrl = response.data.redirect_uri.test;
//       authUrl = response.data.authUrl.test;
//       break;
//     case 'bak':
//       redirectUrl = response.data.redirect_uri.productiionBak;
//       authUrl = response.data.authUrl.productiionBak;
//       break;
//     default:
//       redirectUrl = response.data.redirect_uri.production;
//       authUrl = response.data.authUrl.production;
//       break;
//   }
//   //主题样式文件引入
//   //动态引入
//   // import(`@/assets/css/theme/${theme}.theme.scss`).then(renderApp).catch(function () {
//   //   import('@/assets/css/theme/default.theme.scss').then(renderApp);
//   // })
//   renderApp();
// }).catch(() => {
//   throw 'get baseConfig error...'
// })


Vue.prototype.$config = {
  "baseUrl": process.env.VUE_APP_BASE_API,
  "setting": {
    "theme": "default",
    "menuLayout": "vertical"
  },
  "input": {
    "textareaMinLength": 10,
    "textareaMaxLength": 500
  },
  "workItemLength": {
    "year": {
      "kpi": 100,
      "normal": 100,
      "create": 100,
      "pg": 100
    },
    "month": {
      "kpi": 100,
      "budget": 100,
      "create": 100,
      "normal": 100
    },
    "week": {
      "kpi": 100,
      "create": 100,
      "normal": 100
    },
    "day": {
      "kpi": 100,
      "normal": 100,
      "create": 100,
      "other": 100
    }
  },
  "echarts": {
    "theme": "essos"
  }
}

function renderApp() {
  //开发使用，mock数据
  if (process.env.NODE_ENV !== 'production') {
    // require('@/mock')
  }
  //Vue全局内置配置
  //取消 Vue 所有的日志与警告
  Vue.config.silent = true
  //配置是否允许 vue-devtools 检查代码, 开发版本默认为 true，生产版本默认为 false
  // Vue.config.devtools = true
  //须使 Vue 忽略在 Vue 之外的自定义元素
  Vue.config.ignoredElements = []
  //自定义键位
  Vue.config.keyCodes = {}
  //动态引入模块
  Promise.all([import('./utils'),import('./store'),import('./router'),import('./utils/i18n')]).then(result=>{
    //自定义公共逻辑
    const Utils = result[0].default
    //Vuex引入及配置
    const store = result[1].default
    //router引入及配置
    const router = result[2].default
    //多语言引入及配置
    const i18n = result[3].default
    //载入,包含语言选择
    Vue.use(ElementUI,{
      i18n: (key, value) => i18n.t(key, value)
    })
    //载入表格组件
    Vue.use(VXETable)
    //载入核心公共逻辑
    Vue.use(Utils)
    VXETable.use(VXETablePluginElement)
    // 记录store初始状态
    // window[config.store] = JSON.parse(JSON.stringify(store.state))
    //实例化及全局配置
    Vue.prototype.$getRowExpandFlag = () => {
      // 是否启用年、月、周、绩效考核等表格行点击时展开行内容
      const flag = localStorage.getItem('_rowExpandFlag');
      return !flag || flag === '1';
    }
    new Vue({
      i18n,
      store,
      router,
      render: h => h(App),
      beforeCreate(){
        //安装全局事件总线
        Vue.prototype.$bus =this;
      }
    }).$mount('#app')
  })
}
renderApp();